import {loadLocalState, saveLocalState} from "../utils/AppHelper"
import moment from 'moment'

const persistedState = loadLocalState("dataExports")
const initialState = persistedState || []

function dataExports(state=initialState, action) {
  switch (action.type) {
    case 'LOGOUT_SUCCESS':
      saveLocalState("dataExports", [])
      return []

    case 'GENERATE_REPORT':
      const actionPayloadNames = action.payload.map(d=>d.file_name)

      var newState = [
        ...action.payload,
        ...state.filter(d=> !actionPayloadNames.includes(d.file_name))
      ]

      saveLocalState("dataExports", newState)

      return newState

    case "CANCEL_DATA_EXPORT":
      return [
        ...state.filter(d=> d==action.dataExport)
      ]

    case "GET_DATA_EXPORTS_SUCCESS":

      const getActionDataExportByName = (name) => action.dataExports.exports.find(d=>d.file_name == name)

      const processingExports = state.filter(d=>{
        if (!d.isGenerating) return false

        // compare with server data
        const serverDataExport = getActionDataExportByName(d.file_name)
        // return true if unique name
        if (!serverDataExport) return true

        // if local is newer or same as server debugging ...
        const localLastModified = moment(d.last_modified)
        const serverLastModified = moment(serverDataExport.last_modified)
        const diff = localLastModified.diff(serverLastModified)
        const oldLocal = new Date(d.last_modified)
        const oldServer = new Date(serverDataExport.last_modified)
        const oldDiff = oldLocal - oldServer
        const isNewer = oldDiff>0
        const oldIsNewer = oldLocal >= oldServer
        console.log({localLastModified, serverLastModified, diff, oldDiff, oldServer, isNewer, oldIsNewer})

        // if duplicate, but newer last_modified?
        if (isNewer) return true
        // else, serverDataExport matched and
        return false
      })


      const processingExportsNames = processingExports.map(d=>d.file_name)

      var newState = [
        ...processingExports,
        ...action.dataExports.exports.filter(d=>!processingExportsNames.includes(d.file_name))
      ]

      saveLocalState("dataExports", newState)

      return newState


    default:
      return state
  }
}

export default dataExports



// WEBPACK FOOTER //
// ./src/models/dataExports.js